{
  "pt": {
    "tenant": {
      "actions": {
        "changeCompanyLogo": "Alterar logótipo (png necessário)",
        "changeThemeColor": "Escolher uma nova cor para o tema"
      },
      "errors": {
        "themeColorInvalid": "Introduza seis caracteres, 0-9 ou A-F. Por exemplo 096553."
      },
      "labels": {
        "customerThemeColor": "Cor do tema do cliente",
        "customerThemeColorExlainer": "Esta cor será utilizada para o portal do cliente. Faça-se passar por um cliente para ver isto em ação.",
        "logo": "Logótipo"
      },
      "picture_logo_format": {
        "round": "Logótipo redondo",
        "square": "Logótipo quadrado"
      }
    }
  }
}
